const UrlApi = {
  // baseUrlUsers: "http://localhost:26948/user/",
  // baseUrl: "http://localhost:26948/admin/",
  // baseUrlImage: "http://localhost:26948/user/uploads/",
  baseUrlUsers: "https://api-dev.brainstationclinics.com/user/", // dev
  baseUrl: "https://api-dev.brainstationclinics.com/admin/", // dev
  baseUrlImage: "https://api-dev.brainstationclinics.com/uploads/", // dev
  // baseUrlUsers: "https://api.brainstationclinics.com/user/", // live
  // baseUrl: "https://api.brainstationclinics.com/admin/", // live
  // baseUrlImage: "https://api.brainstationclinics.com/uploads/", // live
  // baseUrlUsers: process.env.REACT_APP_API_URL_USERS, // env
  // baseUrl: process.env.REACT_APP_API_URL, // env
  // baseUrlImage: process.env.REACT_APP_API_URL_IMAGES, // env
  auth: {
    login: "auth/login",
    autologin: "auth/autologin",
    signup: "auth/signup",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
  },
  admins: {
    get: "admins/get",
    add: "admins/add",
    edit: "admins/edit",
    delete: "admins/delete",
    getUserType: "admins/get_user_type",
    getUserPrivilegs: "admins/privileg",
    addUserPrivilegs: "admins/addprivileg",
    editUserPrivilegs: "admins/editprivileg",
    deleteprivileg: "admins/deleteprivileg",
  },
  flashcard: {
    category: {
      get: "flash_cards/category/get",
      add: "flash_cards/category/add",
      edit: "flash_cards/category/edit",
      delete: "flash_cards/category/delete",
    },
    flashcard: {
      get: "flash_cards/flash_cards/get",
      getByCategory: "flash_cards/flash_cards/getByCategory",
      add: "flash_cards/flash_cards/add",
      edit: "flash_cards/flash_cards/edit",
      delete: "flash_cards/flash_cards/delete",
    },
    flashcardDetails: {
      get: "flash_cards/flash_card_details/get",
      add: "flash_cards/flash_card_details/add",
      edit: "flash_cards/flash_card_details/edit",
      delete: "flash_cards/flash_card_details/delete",
    },
    level_of_difficulty: {
      get: "flash_cards/level_of_difficulty/get",
      add: "flash_cards/level_of_difficulty/add",
      edit: "flash_cards/level_of_difficulty/edit",
      delete: "flash_cards/level_of_difficulty/delete",
    },
    age_range: {
      get: "flash_cards/age_range/get",
      add: "flash_cards/age_range/add",
      edit: "flash_cards/age_range/edit",
      delete: "flash_cards/age_range/delete",
    },
  },
  landingPage: {
    sliderShow: {
      get: "landing_page/slider_show/get",
      add: "landing_page/slider_show/add",
      edit: "landing_page/slider_show/edit",
      delete: "landing_page/slider_show/delete",
    },
    maps: {
      get: "landing_page/maps/get",
      add: "landing_page/maps/add",
      edit: "landing_page/maps/edit",
      delete: "landing_page/maps/delete",
    },
    languages: {
      get: "landing_page/languages/get",
      add: "landing_page/languages/add",
      edit: "landing_page/languages/edit",
      delete: "landing_page/languages/delete",
    },
    our_client: {
      get: "landing_page/our_client/get",
      add: "landing_page/our_client/add",
      edit: "landing_page/our_client/edit",
      delete: "landing_page/our_client/delete",
    },
    testimonials: {
      get: "landing_page/testimonials/get",
      add: "landing_page/testimonials/add",
      edit: "landing_page/testimonials/edit",
      delete: "landing_page/testimonials/delete",
    },
    app_benefits: {
      get: "landing_page/app_benefits/get",
      add: "landing_page/app_benefits/add",
      edit: "landing_page/app_benefits/edit",
      delete: "landing_page/app_benefits/delete",
    },
    impacts: {
      get: "landing_page/impacts/get",
      add: "landing_page/impacts/add",
      edit: "landing_page/impacts/edit",
      delete: "landing_page/impacts/delete",
    },
    stats: {
      get: "landing_page/stats/get",
      add: "landing_page/stats/add",
      edit: "landing_page/stats/edit",
      delete: "landing_page/stats/delete",
    },
    press_blog_news: {
      get: "landing_page/press_blog_news/get",
      add: "landing_page/press_blog_news/add",
      edit: "landing_page/press_blog_news/edit",
      delete: "landing_page/press_blog_news/delete",
    },
    ourteam: {
      get: "landing_page/ourteam/get",
      add: "landing_page/ourteam/add",
      edit: "landing_page/ourteam/edit",
      delete: "landing_page/ourteam/delete",
    },
  },
  settings: {
    get: "settings/get",
    edit: "settings/edit/1",
  },
  tips: {
    get: "tips/get",
    add: "tips/add",
    edit: "tips/edit",
    delete: "tips/delete",
  },
  how_it_work: {
    get: "how_it_work/get",
    add: "how_it_work/add",
    edit: "how_it_work/edit",
    delete: "how_it_work/delete",
  },
  activities: {
    category: {
      get: "activities/category/get",
      add: "activities/category/add",
      edit: "activities/category/edit",
      delete: "activities/category/delete",
    },
    activities: {
      get: "activities/activities/get",
      add: "activities/activities/add",
      edit: "activities/activities/edit",
      delete: "activities/activities/delete",
    },
    activities_media: {
      get: "activities/activities_media/get",
      add: "activities/activities_media/add",
      edit: "activities/activities_media/edit",
      delete: "activities/activities_media/delete",
    },
    activities_flashcard: {
      get: "activities/activities_flashcard/get",
      add: "activities/activities_flashcard/add",
      edit: "activities/activities_flashcard/edit",
      delete: "activities/activities_flashcard/delete",
    },
  },
  topics: {
    get: "topics/get",
    add: "topics/add",
    edit: "topics/edit",
    delete: "topics/delete",
  },
  contact_as: {
    get: "contact_as/get",
    add: "contact_as/add",
    edit: "contact_as/edit",
    delete: "contact_as/delete",
  },
  faqs: {
    get: "faqs/get",
    add: "faqs/add",
    edit: "faqs/edit",
    delete: "faqs/delete",
  },
  users: {
    get: "users/get",
    add: "users/add",
    edit: "users/edit",
    delete: "users/delete",
    get_countries: "users/get_countries",
  },
  admin_logs: {
    get: "admin_logs/get",
    edit: "admin_logs/edit",
  },
  dashboard: {
    topic: "dashboard/topic",
    cateogry: "dashboard/cateogry",
    activity: "dashboard/activity",
    flash_card_used: "dashboard/flash_card_used",
    flash_card_viewed: "dashboard/flash_card_viewed",
    active_users: "dashboard/active_users",
  },
  notification: {
    sendbroadcastnotifcation: "notification/sendbroadcastnotifcation",
  },
  reOrder: "re-order",
  events: {
    get: "events/get-admin",
    delete: "events/delete",
    add: "events/add",
    edit: "events/edit",
  },
  intro: {
    get: "intro/get-admin",
    edit: "intro/edit",
    add: "intro/add",
    delete: "intro/delete",
  },
  join_our_team: {
    get: "join-team/get-admin",
    edit: "join-team/edit",
    add: "join-team/add",
    delete: "join-team/delete",
  },
  address: {
    get: "address/get-admin",
    edit: "address/edit",
    add: "address/add",
    delete: "address/delete",
  },
  media_list: {
    get: "medialist/get-admin",
    edit: "medialist/edit",
    add: "medialist/add",
    delete: "medialist/delete",
  },
  sub_services: {
    get: "sub-services/get-admin",
    edit: "sub-services/edit",
    add: "sub-services/add",
    delete: "sub-services/delete",
  },
  training_workshops: {
    get: "training-workshops/get-admin",
  },
  courses: {
    get: "courses/get-admin",
    edit: "courses/edit",
    add: "courses/add",
    delete: "courses/delete",
  },

  categories: {
    get: "categories/get-admin",
    edit: "categories/edit",
    add: "categories/add",
    delete: "categories/delete",
  },
  media_types: {
    get: "mediatypes/get",
    edit: "mediatypes/edit",
    add: "mediatypes/add",
    delete: "mediatypes/delete",
  },
  media_gallery: {
    get: "mediagallery/get",
    edit: "mediagallery/edit",
    add: "mediagallery/add",
    delete: "mediagallery/delete",
    get_events: "mediagallery/get_events",
    get_media_list: "mediagallery/get_media_list",
    get_sub_services: "mediagallery/get_sub_services",
    get_about_us_media_gallery: "mediagallery/about_us_gallery",
    get_clinic_media_gallery: "mediagallery/our_clinic_gallery",
  },
  course_files: {
    get: "course-files/get-admin",
    edit: "course-files/edit",
    add: "course-files/add",
    delete: "course-files/delete",
  },
  client_orders: {
    get: "client-orders/get-admin",
    get_emails: "client-orders/get-emails",
    edit: "client-orders/edit",
    add: "client-orders/add",
    delete: "client-orders/delete",
  },
  cbt: {
    get: "cbt/get-admin",
    activate: "cbt/activate",
    deactivate: "cbt/deactivate",
    delete: "cbt/delete",
  },
  webhook_locks: {
    get: "webhook-locks",
    by_order: "webhook-locks/order",
    duplicate_orders: "webhook-locks/duplicate-orders",
    duplicate_courses: "webhook-locks/duplicate-courses",
    diagnostic: "webhook-locks/diagnostic",
  },
  values: {
    get: "values/get-admin",
    edit: "values/edit",
    add: "values/add",
    delete: "values/delete",
  },
  whyUs: {
    get: "why-us/get-admin",
    edit: "why-us/edit",
    add: "why-us/add",
    delete: "why-us/delete",
  },
  slider: {
    get: "hero-slider/get-admin",
    edit: "hero-slider/edit",
    add: "hero-slider/add",
    delete: "hero-slider/delete",
  },
  testimonials: {
    get: "testimonials/get",
    get_admin: "testimonials/get-admin",
    edit: "testimonials/edit",
    add: "testimonials/add",
    delete: "testimonials/delete",
  },
  team: {
    get: "team/get-admin",
    edit: "team/edit",
    add: "team/add",
    delete: "team/delete",
  },
  main_services: {
    get: "main-services/get-admin",
    edit: "main-services/edit",
    add: "main-services/add",
    delete: "main-services/delete",
  },
  seo: {
    get: "seo/get-admin",
    edit: "seo/edit/2",
    add: "seo/add",
    delete: "seo/delete",
  },
};

export default UrlApi;
